const BRANDING_SERVICE_API_URL = 'https://api.branding.cimpress.io/v1/current-brand?include=*';

export const fetchBrandingInfo = (accessToken, sessionId) => {
  let fetchUrl = BRANDING_SERVICE_API_URL;
  let fetchMethod = 'get';

  if (!accessToken) {
    //reset variables to proxy values
    fetchUrl = `https://sessions.cimpress.io/v1/sessions/proxy?proxyUrl=${encodeUriComponent(
      fetchUrl
    )}&proxyUrlMethod=${fetchMethod}`;
    fetchMethod = 'post';
  }

  return fetch(fetchUrl, {
    method: fetchMethod,
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : { 'x-session-id': sessionId }),
    }),
    ...(!accessToken && { body: JSON.stringify({}) }),
  })
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        return null;
      }
    })
    .catch(error => {
      console.error(error);
      return null;
    });
};
